/*
 * price-mode-toggle.js - 3DDruckBoss B2B Netto/Brutto display toggle
 * DISPLAY-ONLY convenience for B2B buyers. The Shopify checkout ALWAYS charges
 * the legal gross (brutto) price. The net figure is a client-side, informational
 * estimate (gross / (1 + VAT)) and is labelled "zzgl. USt., unverbindlich".
 * Config is read from data-* attributes so this file needs no Liquid.
 */
(function () {
  'use strict';

  function init() {
    var root = document.getElementById('b2b-price-tool');
    if (!root) return;

    var TAX_RATE = parseFloat(root.getAttribute('data-tax-rate')) || 0.19;
    var THRESHOLD = parseInt(root.getAttribute('data-threshold'), 10) || 300000;
    var STORAGE_KEY = root.getAttribute('data-storage-key') || 'b2b_price_mode';
    var currency = root.getAttribute('data-currency') || 'EUR';
    var currentGross = parseInt(root.getAttribute('data-current-gross'), 10) || 0;

    var variantPrices = {};
    try { variantPrices = JSON.parse(root.getAttribute('data-variant-prices') || '{}'); }
    catch (e) { variantPrices = {}; }

    var fmt;
    try { fmt = new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }); }
    catch (e) { fmt = { format: function (v) { return v.toFixed(2) + ' ' + currency; } }; }

    var toggle = document.getElementById('b2b-price-mode-toggle');
    var panel = document.getElementById('b2b-net-panel');
    var netEl = document.getElementById('b2b-net-price');
    var grossEl = document.getElementById('b2b-gross-ref');
    var quoteCta = document.getElementById('b2b-quote-cta');
    var quoteLnk = document.getElementById('b2b-quote-link');

    window.dataLayer = window.dataLayer || [];

    function selectedGross() {
      var sel = document.querySelector('input[name="id"]:checked') ||
                document.querySelector('select[name="id"]');
      var id = sel ? sel.value : null;
      if (id && variantPrices[id] != null) return variantPrices[id];
      return currentGross;
    }

    function getMode() {
      try { return localStorage.getItem(STORAGE_KEY) || 'brutto'; }
      catch (e) { return 'brutto'; }
    }

    function render(mode) {
      var gross = selectedGross();
      var isNet = mode === 'netto';
      if (panel) {
        if (isNet) {
          var net = Math.round(gross / (1 + TAX_RATE));
          if (netEl) netEl.textContent = fmt.format(net / 100);
          if (grossEl) grossEl.textContent = fmt.format(gross / 100);
          panel.hidden = false;
        } else {
          panel.hidden = true;
        }
      }
      if (quoteCta) {
        quoteCta.hidden = !(isNet || gross >= THRESHOLD);
      }
    }

    var initial = getMode();
    if (toggle) {
      toggle.checked = (initial === 'netto');
      toggle.addEventListener('change', function () {
        var mode = toggle.checked ? 'netto' : 'brutto';
        try { localStorage.setItem(STORAGE_KEY, mode); } catch (e) {}
        render(mode);
        window.dataLayer.push({ event: 'b2b_price_mode_toggle', mode: mode });
      });
    }

    if (quoteLnk) {
      quoteLnk.addEventListener('click', function () {
        window.dataLayer.push({
          event: 'quote_request_click',
          product_id: quoteLnk.getAttribute('data-product-id') || '',
          product_title: quoteLnk.getAttribute('data-product-title') || ''
        });
      });
    }

    document.querySelectorAll('input[name="id"], select[name="id"]').forEach(function (el) {
      el.addEventListener('change', function () { render(getMode()); });
    });

    render(initial);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
